import * as React from 'react'
import { useState } from 'react'
import { noop } from 'lodash'
import MediaQuery from 'react-responsive'
import { connect } from 'react-redux'
import {
  Text,
  StackChildren,
  InlineChildren,
  Breakpoints,
} from '@doordash/design-language'
import { RTFPrivacyFlow } from '../../../models/types'
import Button from '@doordash/component-button'
import * as api from '../../../api'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { ANDROID_CANCEL_DEEPLINK, IOS_CANCEL_DEEPLINK } from '../../pages/privacy-portal'
import ResponsiveWrapper from '../../atoms/responsive-wrapper'
import s from './strings'
import { OsTypes } from '../../../webview/types'
import { isWebview, detectWebviewOs } from '../../../utilities/userAgent'

type Props = {
  setView?: (view: RTFPrivacyFlow) => void
  trackRTF?: (data: DA.RTF) => void
}

const PAGE_NAME = 'confirm-deletion'
const os = detectWebviewOs()

export const ConfirmDeletion: React.FC<Props> = ({ setView = noop, trackRTF = noop }) => {
  const [loading, setLoading] = useState<boolean>(false)

  React.useEffect(() => {
    trackRTF({ action: DA.GDPRActions.Render, name: PAGE_NAME })
  }, [trackRTF])

  const handleDeleteAccountClick = async () => {
    try {
      setLoading(true)
      trackRTF({ action: DA.GDPRActions.Submission, name: PAGE_NAME })
      await api.createDasherRTFRequest()
      // @TODO @phillyqueso-dd: rm -rf token ;-)
      setView(RTFPrivacyFlow.Exit)
    } catch (e) {
      console.warn(e)
      trackRTF({ action: DA.GDPRActions.Error, name: PAGE_NAME })
    } finally {
      setLoading(false)
    }
  }

  const handleCancelClick = () => {
    trackRTF({ action: DA.GDPRActions.Close, name: PAGE_NAME })
    if (isWebview()) {
      window.location.assign(os === OsTypes.iOS ? IOS_CANCEL_DEEPLINK : ANDROID_CANCEL_DEEPLINK)
    } else {
      window.location.reload()
    }
  }

  return (
    <ResponsiveWrapper>
      <StackChildren size={StackChildren.Sizes.Large}>
        <Text styles={Text.Styles.PageTitle2}>{s.confirmDeletion.pageTitle()}</Text>
        <Text styles={Text.Styles.Body1}>{s.confirmDeletion.body1()}</Text>
        <Text styles={Text.Styles.Body1}>{s.confirmDeletion.body2()}</Text>
        <Text styles={Text.Styles.Body1}>{s.confirmDeletion.body3()}</Text>
        <MediaQuery minWidth={Breakpoints.Mobile + 1}>
          <InlineChildren size={InlineChildren.Sizes.XxSmall} justifyContent={InlineChildren.Justification.FlexEnd}>
            <Button
              onClick={handleCancelClick}
              type={Button.Types.Tertiary}
              isInline
            >
              {s.confirmDeletion.cancelButton()}
            </Button>
            <Button
              onClick={handleDeleteAccountClick}
              state={loading ? Button.States.Loading : Button.States.Default}
              isInline
            >
              {s.confirmDeletion.deleteAccountButton()}
            </Button>
          </InlineChildren>
        </MediaQuery>
      </StackChildren>
      <MediaQuery maxWidth={Breakpoints.Mobile}>
        <StackChildren size={StackChildren.Sizes.Small}>
          <Button
            onClick={handleDeleteAccountClick}
            state={loading ? Button.States.Loading : Button.States.Default}
          >
            {s.confirmDeletion.deleteAccountButton()}
          </Button>
          <Button
            onClick={handleCancelClick}
            type={Button.Types.FlatSecondary}
          >
            {s.confirmDeletion.cancelButton()}
          </Button>
        </StackChildren>
      </MediaQuery>
    </ResponsiveWrapper>
  )
}

const mapDispatchToProps = {
  trackRTF: events.trackRTF,
}

export default connect(null, mapDispatchToProps)(ConfirmDeletion)
